var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReloadReadytoclearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.4 82.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,64.3c-4.9,5.2-11.5,8.1-18.7,8.1C21.5,72.4,10,60.9,10,46.8s11.5-25.7,25.7-25.7c3.7,0,7.4,0.8,10.7,2.3 L37.2,26c-2.7,0.7-4.2,3.5-3.5,6.2c0.6,2.2,2.6,3.7,4.8,3.7c0.4,0,0.9-0.1,1.3-0.2l19.9-5.6c1.3-0.4,2.4-1.2,3-2.4 c0.7-1.2,0.8-2.5,0.5-3.8L57.6,3.7c-0.7-2.7-3.5-4.2-6.2-3.5s-4.2,3.5-3.5,6.2l2.1,7.7c-4.5-2-9.4-3-14.4-3C16,11.1,0,27.1,0,46.7 s16,35.6,35.6,35.6c9.8,0,19.2-4.1,25.9-11.2c1.9-2,1.8-5.2-0.2-7.1C59.4,62.1,56.2,62.2,54.3,64.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadReadytoclearIcon);
export default __webpack_public_path__ + "static/media/reload-readytoclear-icon.c7f9e335ffffcd793f46a67fd332103b.svg";
export { ForwardRef as ReactComponent };